"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
function default_1({ confirm, message }) {
    confirm({
        description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { width: "100%", src: "/static/common/images/img_user_profile_add.png" }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("span", Object.assign({ css: { display: 'flex', justifyContent: 'center' } }, { children: `${message}..☆` }))] })),
        cancellationButtonProps: { style: { display: 'none' } },
    });
}
exports.default = default_1;
